import React, { PropsWithChildren, useEffect, useMemo } from 'react';
import styled from 'styled-components';

import 'react-quill/dist/quill.snow.css';
import QuillImageDropAndPaste from 'quill-image-drop-and-paste';

import { ImageDrop } from 'quill-image-drop-module';

import { Quill } from 'react-quill-new';
import QuillTableBetter from 'quill-table-better';
import 'react-quill-new/dist/quill.snow.css';
import 'quill-table-better/dist/quill-table-better.css';

const SizeStyle: any = Quill.import('attributors/style/size');
SizeStyle.whitelist = ['10px', false, '21px', '35px'];
Quill.register(SizeStyle, true);

const BlockEmbed: any = Quill.import('blots/block/embed');

BlockEmbed.tagName = 'hr';
BlockEmbed.blotName = 'divider';

class DividerBlot extends (BlockEmbed as { new (): any }) {
  static blotName = 'divider';
  static tagName = 'hr';
}

Quill.register('blots/divider', DividerBlot);
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);
Quill.register({ 'modules/table-better': QuillTableBetter }, true);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  width: 100%;

  .quill {
    > .ql-container {
      font-family: Pretendard !important;
      border: none;

      /* padding: 12px 20px 40px; */
    }

    img {
      width: 100%;
      border-radius: 7px;
    }

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera*/
    }

    &::placeholder {
      color: #c2c4c8;
      font-size: 14px;
      font-weight: 400;
    }

    .ql-editor {
      /* height: 100%; */
      /* padding: 0 !important; */
      padding: 0;
    }

    /* 사이즈 드롭다운 라벨 */
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='10px']::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='10px']::before {
      content: 'Small';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
      content: 'Normal';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='21px']::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='21px']::before {
      content: 'Large';
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value='35px']::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='35px']::before {
      content: 'Huge';
    }

    .ql-tooltip {
      left: 0 !important;
    }

    .ql-divider::after {
      content: '';
      display: block;
      width: 18px;
      height: 3px;
      background-color: #000;
      position: relative;
      top: 10%;
      transform: translateY(-50%);
    }

    .ql-editor {
      /* caret-color: #0077ff; */
      &::after {
        content: '';
        position: relative;
        z-index: 1; /* 커서의 z-index 설정 */
      }
      /* border: 1px solid red;
      height: 700px;
      max-height: 700px;
      overflow-y: scroll; */
    }

    .ql-editor h1 {
      font-family: Pretendard;
      font-size: 22px;
      font-weight: 700;
      line-height: 160%;
    }

    .ql-editor h2 {
      font-size: 18px;
      font-weight: 700;
      line-height: 160%;
    }

    .ql-editor h3 {
      font-size: 16px;
      font-weight: 400;
      line-height: 160%;
    }

    .ql-editor p {
      font-size: 14px;
      font-weight: 400;
      line-height: 160%;
    }

    .ql-blank {
      font-size: 16px;
      line-height: 160%;
    }

    ol {
      li[data-list='bullet']::before {
        content: '';
      }
    }

    .ql-blank::before {
      position: absolute;
      left: 0;
      font-family: Pretendard !important;
      font-style: normal !important;
      color: #999;
    }

    .ql-formats {
      margin-right: 0;
    }

    .ql-tooltip {
      height: 0;
    }

    .ql-toolbar {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      position: sticky;

      width: 100%;

      border: none;
      border-bottom: 1px solid #eee;
      background-color: #fff;
      z-index: 20;

      .ql-formats:nth-child(2) {
        padding-right: 10px;
        border-right: 1px solid #eaecf0;
      }

      .ql-formats:nth-child(5) {
        padding-right: 8px;
        border-right: 1px solid #eaecf0;
      }

      button {
        width: 22px;
        padding: 0;
        aspect-ratio: 1/1 !important;
      }

      svg {
        width: 22px !important;
        height: 22px !important;
      }

      .ql-formats {
        margin-right: 0;

        > button {
          &.ql-table-better {
            width: 18px;
            height: 18px;

            svg {
              width: 18px !important;
              height: 18px !important;
            }
          }
        }
      }
    }

    table {
      * {
        box-sizing: border-box;
      }

      &.ql-table-better {
      }

      tbody {
      }

      tr {
        -webkit-border-width: 1px;
        border-width: 1px !important;
      }

      td {
        display: table-cell;
        vertical-align: inherit;
        border: 1px solid #000;
        padding: 2px 5px;
        -webkit-border-width: 1px;
        border-width: 1px !important;
      }
    }

    table {
      * {
        box-sizing: border-box;
      }

      &.ql-table-better {
      }

      tbody {
      }

      tr {
        -webkit-border-width: 1px;
        border-width: 1px !important;
      }

      td {
        display: table-cell;
        vertical-align: inherit;
        border: 1px solid #000;
        padding: 2px 5px;
        -webkit-border-width: 1px;
        border-width: 1px !important;
      }
    }
  }
`;

export const toolbarContainer = [
  [{ size: ['10px', false, '21px', '35px'] }],
  [{ font: [] }],
  [{ header: 1 }, { header: 2 }],
  ['bold'],
  ['italic'],
  ['underline'],
  ['strike'],
  ['divider'],
  // ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: [] }],
  ['link'],
  ['video'],
  ['image'],
  ['table-better'],
];

export const formats = [
  'size',
  'header',
  'bold',
  'font',
  'italic',
  'underline',
  'strike',
  'color',
  'background',
  'list',
  'bullet',
  'align',
  'link',
  'video',
  'image',
  'divider',
  'table',
];

interface Props extends PropsWithChildren {}

const EditorFormat = (props: Props) => {
  const { children } = props;

  useEffect(() => {
    // MutationObserver로 비디오 요소 감시
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          const videos = document.querySelectorAll('.ql-video');
          videos.forEach(video => {
            video.setAttribute(
              'style',
              'width: 100%; aspect-ratio: 2/1; max-width: 100%;',
            );
          });
        }
      });
    });

    const editorElement = document.querySelector('.ql-editor');
    if (editorElement) {
      observer.observe(editorElement, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return <Container>{children}</Container>;
};

export default EditorFormat;
